import {
  Checkbox,
  createStyles,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  makeStyles,
  Paper,
  Theme,
  Typography,
  TextField,
  InputAdornment,
  Button,
} from '@material-ui/core';
import React, { FC, useCallback, useEffect, useState } from 'react';
import { Devices } from '../../api/infomodul/models';
import * as infomodul from '../../api/infomodul';
import PendingDialog from '../dialogs/PendingDialog';
import SearchIcon from '@material-ui/icons/Search'


const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    fullHeight: {
      height: '80vh',
      overflow: 'scroll',
    },
  })
);

interface Props {
  selectedDevices: number[];
  setSelectedDevices: React.Dispatch<React.SetStateAction<number[]>>;
  selectedDevicesIds: number[];
  setSelectedDevicesIds: React.Dispatch<React.SetStateAction<number[]>>;
  deviceData: Devices[];
  deviceBoxDisabled: boolean;
  masterID: number;
}

const DeviceList: FC<Props> = ({
  deviceData,
  selectedDevices,
  setSelectedDevices,
  deviceBoxDisabled,
  masterID,
  selectedDevicesIds,
  setSelectedDevicesIds,
}) => {
  const classes = useStyles();
  const [sbsPortNr, setSbsPortNr] = useState<string[]>([]);
  const [selectAll, setSelectAll] = useState<boolean>(false);
  const [inputText, setInputText] = useState("");
  const [filteredDeviceData, setFilteredDeviceData] = useState(deviceData);

  const inputHandler = (e:any) => {
    const lowerCase = e.target.value.toLowerCase();
    setInputText(lowerCase);
  
    const filteredData = deviceData.filter((value) =>
      value.deviceName.toLowerCase().includes(lowerCase)
    );
    
    setFilteredDeviceData(filteredData);
  };


  //API call to get sbsport number used for inserting devices in device table
  const getSbsPortNum = useCallback(() => {
    infomodul.getSbsPortNum({ masterId: masterID }).then((data) => {
      setSbsPortNr(data.data);
    });
  }, [masterID]);

  useEffect(() => {
    getSbsPortNum();
  }, [getSbsPortNum]);

  useEffect(() => {
    setFilteredDeviceData(deviceData);
  }, [deviceData]);

  useEffect(() => {
    if(deviceBoxDisabled)
    {
      setInputText("");
      setFilteredDeviceData(deviceData);
    }
  }, [deviceBoxDisabled])


    // useEffect(() => {
    //   console.log('useeffect111');
    //   setAB(prev => {
    //     return (deviceData !== prev.deviceData && sbsPortNr !== prev.sbsPortNr && sbsPortNr.length > 0) 
    //       ? {deviceData,sbsPortNr} 
    //       : prev;
    //   })
    // }, [deviceData, sbsPortNr])

    // useEffect(() => {
    //   console.log('test: '+test);
    //   console.log('lengthhhh: '+sbsPortNr.length);
    //   // getSbsPortNum();
    //   if (sbsPortNr.length > 0 && deviceData.length > 0) {
    //     console.log("masterport: "+sbsPortNr[0]);
    //     console.log('device data: '+deviceData.length);
    //       infomodul.UpdateDevices({
    //         body: {
    //           masterPort: Number(sbsPortNr[0]),
    //           devices:deviceData,
    //         },
    //       });
    //   } else {
    //     return;
    //   }
    // }, [ab]);


  //Posts devices to database if not already in the table
  // useEffect(() => {
  //   if (sbsPortNr) {
  //     if (sbsPortNr.length > 0) {
  //       //      for (let i = 0; i < deviceData.length; i++) {
  //       infomodul.UpdateDevices({
  //         body: {
  //           masterPort: Number(sbsPortNr[0]),
  //           devices: deviceData,

  //           /*             clientHash: deviceData[i].clientHash,
  //                       masterID: masterID,
  //                       deviceName: deviceData[i].deviceName,
  //                       deviceNumber: deviceData[i].deviceId, */
  //         },
  //       });
  //     }
  //     else {
  //       return;
  //     }
  //   } else {
  //     return;
  //   }
  // }, [deviceData, masterID, sbsPortNr]);

  

  //Handles toggling devices and passing the toggled devices to setSelectedDevices
  const handleToggle = (i: number, devid: number) => () => {
    const currentIndex = selectedDevices.indexOf(i);
    const newChecked = [...selectedDevices];
    const devIdIndex = selectedDevicesIds.indexOf(devid);
    const idArr = [...selectedDevicesIds];

    if (currentIndex === -1 && devIdIndex === -1) {
      newChecked.push(i);
      idArr.push(devid);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    if (devIdIndex !== -1) {
      idArr.splice(devIdIndex, 1);
    }

    setSelectedDevices(newChecked);
    setSelectedDevicesIds(idArr);
    //alert('handleToggle '+idArr.length+' '+selectedDevicesIds.length);
  };

  const handleSelectAll = (event: React.ChangeEvent<HTMLInputElement>) => {
    if(deviceBoxDisabled){
      setSelectAll(false);
      setSelectedDevices([]);
      setSelectedDevicesIds([]);
      return;
    }
    let devices: number[] = [];
    let devicesIds: number[] = [];
    if (event.target.name === 'selectAll' && selectAll === false ) {
      for (let i = 0; i < deviceData.length; i++) {
        devices.push(i);
        devicesIds.push(deviceData[i].deviceNumber);
      }
      setSelectedDevices(devices);
      setSelectAll(!deviceBoxDisabled);
    } else {
      setSelectedDevices([]);
      setSelectAll(false);
    }
    setSelectedDevicesIds(devicesIds);
  };



  return (
    <div style={{backgroundColor: '#ffffff', borderRadius: '6px', overflow: 'hidden', borderBottomWidth: '0px'}}>
      <div className='search' style={{marginTop: '5px'}}>
        <TextField
          id="outlined-basic"
          onChange={inputHandler}
          value={deviceBoxDisabled?"":inputText}
          variant='outlined'
          placeholder='Søg på automater...'
          fullWidth
          disabled={deviceBoxDisabled}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
          />
      </div>
      <div style={{marginTop: '5px'}}>
        <h5>Antal Automater Valgt: {selectedDevicesIds.length}</h5>
      </div>
      <Button style={{marginTop: '-10px', marginBottom: '5px'}}
              variant="contained"
              color="primary"
              disabled={deviceBoxDisabled || selectedDevicesIds.length < 1}
              onClick={() => {
                setSelectedDevices([]);
                setSelectedDevicesIds([]);
                setSelectAll(false);
              }}
            >
              Fravælg Alle
            </Button>
    <Paper className={classes.fullHeight} elevation={0}>
      <Typography component="h2" variant="h5">
        Automater
      </Typography>
      <List>
        <ListItem 
            disabled={deviceBoxDisabled}
          >
          <ListItemIcon>
            <Checkbox
              edge="start"
              color="primary"
              checked={selectAll &&!deviceBoxDisabled}
              onChange={handleSelectAll}
              tabIndex={-1}
              disableRipple
              name="selectAll"
              disabled={deviceBoxDisabled}
              
            />
          </ListItemIcon>
          <ListItemText
            id={'selectAll'}
            primary={
              <Typography style={{ fontWeight: 'bold' }}>Vælg alle</Typography>
            }
          />
        </ListItem>
        {filteredDeviceData.map((value, i) => {
          const labelId = `checkbox-list-label-${value}`;
          return (
            <ListItem
              key={i}
              role={undefined}
              dense
              button
              disabled={deviceBoxDisabled}
              onClick={handleToggle(i, value.deviceNumber)}
            >
              <ListItemIcon>
                <Checkbox
                  edge="start"
                  color="primary"
                  checked={(selectedDevices.indexOf(i) !== -1 || selectedDevicesIds.indexOf(value.deviceNumber) != -1)
                    && !deviceBoxDisabled} 
                  tabIndex={-1}
                  disableRipple
                  inputProps={{ 'aria-labelledby': labelId }}
                />
              </ListItemIcon>
              <ListItemText id={labelId} primary={value.deviceName} />
            </ListItem>
          );
        })}
      </List>
      <PendingDialog open={false} title={'Loading'} />
    </Paper>
    </div>
  );
};

export default DeviceList;
